// A4.29 — guruh/kanal verifikatsiyasi adapter. Module-local. Verifikatsiya
// belgisini berish/olib tashlash (dialogs.verified) — bot verifikatsiyasi kabi.
import { api } from '@/lib/api'

export async function setGroupVerified(groupId: number, verified: boolean): Promise<void> {
  await api.post(`/admin/groups/${groupId}/verify`, { verified })
}

// A4.28 — egalikni ma'muriy o'tkazish. Yangi ega FAOL a'zo bo'lishi shart
// (backend tekshiradi). Eski ega adminga tushiriladi.
export async function transferGroupOwner(groupId: number, newOwnerId: number): Promise<void> {
  await api.post(`/admin/groups/${groupId}/transfer-owner`, { new_owner_id: newOwnerId })
}

// A4.30 — @username'ni majburan bo'shatish (skvatting/haqoratli). Bo'shatilgan
// username'ni qaytaradi. dialogs.username=NULL → username qaytadan olinishi mumkin.
export async function releaseGroupUsername(groupId: number): Promise<string> {
  const r = await api.post<{ released_username: string }>(`/admin/groups/${groupId}/release-username`, {})
  return r.released_username
}

// A4.27 — guruh/kanalni ma'muriy BLOKLASH/ochish. Bloklanganda send yo'li har
// xabarni rad etadi (enforcement backendда). reason blok sababi.
export async function setGroupBlocked(groupId: number, blocked: boolean, reason: string): Promise<void> {
  await api.post(`/admin/groups/${groupId}/block`, { blocked, reason })
}
